/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IStripeLocationCreateRequest } from '../models/IStripeLocationCreateRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SalesConfigPaymentTerminalsLocationsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any
     * @throws ApiError
     */
    public postSalesConfigPaymentTerminalsLocationsCreate({
        requestBody,
    }: {
        requestBody: IStripeLocationCreateRequest,
    }): CancelablePromise<{
        ok: boolean;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/sales/config/payments/terminals/locations',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
